const LogoutIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.16665 2.49984C9.16665 2.0396 9.53974 1.6665 9.99998 1.6665C10.4602 1.6665 10.8333 2.0396 10.8333 2.49984V7.49984C10.8333 7.96007 10.4602 8.33317 9.99998 8.33317C9.53974 8.33317 9.16665 7.96007 9.16665 7.49984V2.49984ZM12.9625 4.02572C12.5503 3.8209 12.3822 3.32075 12.5871 2.9086C12.7919 2.49645 13.292 2.32838 13.7042 2.5332C16.4461 3.89581 18.3333 6.72668 18.3333 9.99986C18.3333 14.6022 14.6024 18.3332 9.99998 18.3332C5.39761 18.3332 1.66665 14.6022 1.66665 9.99986C1.66665 6.72668 3.55388 3.89581 6.29578 2.5332C6.70793 2.32838 7.20809 2.49645 7.41291 2.9086C7.61773 3.32075 7.44966 3.8209 7.03751 4.02572C4.84035 5.11762 3.33331 7.38351 3.33331 9.99986C3.33331 13.6818 6.31808 16.6665 9.99998 16.6665C13.6819 16.6665 16.6666 13.6818 16.6666 9.99986C16.6666 7.38351 15.1596 5.11762 12.9625 4.02572Z"
        className="fill-color"
      />
    </svg>
  );
};

export default LogoutIcon;
